/* eslint-disable */
import React, { useEffect, useState } from "react";

import {
  Alert,
  Button,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Grid2,
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  IconButton,
  Tooltip,
  Icon,
  TextField,
  Rating,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import constants from "../static/constants.json";
import dayjs from "dayjs";
import { JobsAPI } from "../apis/jobsApi";
import { Map, AdvancedMarker, Pin } from "@vis.gl/react-google-maps";
import JobHistory from "./JobHistory";
import { Carousel } from "react-responsive-carousel";
import { editJob, removeJob } from "../redux/jobSlice";
import {
  chattableStatuses,
  completedStatuses,
  editableStatuses,
} from "../static/static";
import {
  addressToStringFull,
  getJobStatusName,
  getJobTypeName,
  getPropertyTypeName,
  timeToDayShort,
  timeToTimeOfDayShort,
} from "../utils/utils";
import { useNavigate } from "react-router";
import {
  CheckCircle,
  Close,
  ContentCopy,
  MapOutlined,
} from "@mui/icons-material";
import RequestsDialog from "./RequestsDialog";
import useAsyncEffect from "use-async-effect";
import { addRequest, dismissRequestsForJobId } from "../redux/requestSlice";
import { UserAPI } from "../apis/userApi";
import { setUser } from "../redux/userSlice";
import { RatingsAPI } from "../apis/ratingsAPI";
import { EventsAPI } from "../apis/eventsAPI";
import { seeEvents } from "../redux/eventSlice";
import UserPanel from "./UserPanel";
import JobCompleteDialog from "./JobCompleteDialog";
import JobStartDialog from "./JobStartDialog";
import { mainButtonStyle } from "../static";
type JobDialogProps = {
  job: any;
  open: boolean;
  handleClose: () => void;
  onComplete?: () => void;
};

const JobDetailsDialog = ({
  job,
  open,
  handleClose,
  onComplete,
}: JobDialogProps) => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const requests = useSelector((state: any) => state.requests.list);

  const [jobToDelete, setJobToDelete] = useState({} as any);
  const [propertyId, setPropertyId] = useState("");
  const [typeId, setTypeId] = useState("");
  const [showMsg, setShowMsg] = useState(false);
  const [msg, setMsg] = useState("");
  const [instructions, setInstructions] = useState("");
  const navigate = useNavigate();
  const tasks = useSelector((state: any) => state.tasks.list);
  const [beforeImages, setBeforeImages] = useState([] as string[]);
  const [afterImages, setAfterImages] = useState([] as string[]);
  const [rejecting, setRejecting] = useState(false);
  const [approving, setApproving] = useState(false);
  const [leavingRating, setLeavingRating] = useState(false);
  const [ratingValue, setRatingValue] = useState<number | null>(null);
  const [ratingComment, setRatingComment] = useState<string>("");
  const [showMap, setShowMap] = useState(false);
  const [reviewingRequest, setReviewingRequest] = useState(false);
  const [filteredRequests, setFilteredRequests] = useState([] as any[]);
  const [startingJob, setStartingJob] = useState({} as any);
  const [completingJob, setCompletingJob] = useState({} as any);
  useEffect(() => {
    if (job && job.id) {
      setPropertyId(job.propertyId);
      setTypeId(job.typeId);
      setInstructions(job.instructions);
      if (job.images) {
        setBeforeImages(
          job.images
            .filter((i: any) => i.eventTypeId === constants.eventType.started)
            .map((i: any) => i.path)
        );
        setAfterImages(
          job.images
            .filter((i: any) => i.eventTypeId === constants.eventType.completed)
            .map((i: any) => i.path)
        );
      }

      if (job.events) {
        // this user should see these events
        const eventsToSee = job.events
          .filter((e: any) => {
            return e.jobId === job.id && e.actorId !== user.id;
          })
          .map((e: any) => e.id);
        seeTheseEvents(eventsToSee);
      }

      // TODO determine if reviewing requests

      // if (user.id === job.managerId && job.statusId === constants.jobStatus.open && job.requests.length > 0) {
      //   console.log('should review requests');
      //   setReviewingRequest(true);
      // }
    }
  }, [job]);

  useEffect(() => {
    const requestsForThisJob = requests.filter((r: any) => r.jobId === job.id);
    if (
      requestsForThisJob.length > 0 &&
      user.personTypeId === constants.personType.propertyManager
    ) {
      setReviewingRequest(true);
      setFilteredRequests(requestsForThisJob);
    }
  }, [requests, job]);

  const seeTheseEvents = async (eventIds: string[]) => {
    try {
      await EventsAPI.markAsSeen(eventIds);
      dispatch(seeEvents(eventIds));
    } catch (error) {
      console.log("failed to see events");
    }
  };

  useAsyncEffect(async () => {
    console.log("job details opened so pulling everything about the job");
    if (job && job.id) {
      try {
        const j = await JobsAPI.getJob(job.id);
        dispatch(editJob(j));
      } catch (e) {
        alert(`Error: ${e}`);
        handleClose();
      }
    }
  }, [job.id]);

  const getMessageForEventTypeSuccess = (eventTypeId: string) => {
    switch (eventTypeId) {
      case constants.eventType.assigned:
        return "Job assigned";
      case constants.eventType.rejected:
        return "Job rejected";
      case constants.eventType.accepted:
        return "Job approved";
      case constants.eventType.requested:
        return "Job requested";
      default:
        return "Unknown event happened";
    }
  };

  const rateJob = async () => {
    const body = {
      value: ratingValue,
      workerId: job.assigneeId,
      jobId: job.id,
      comment: ratingComment,
    };
    try {
      await RatingsAPI.create(body);
      setLeavingRating(false);
      setReviewingRequest(false);
      setMsg("Submitted");
      setShowMsg(true);

      handleClose();
    } catch (e) {
      alert(`Error: ${e}`);
      handleClose();
    }
  };

  const deleteJob = async (id: string) => {
    try {
      await JobsAPI.deleteJob(id);
      handleClose();
      dispatch(removeJob({ id }));
      setMsg("Job cancelled");
    } catch (error) {
      console.log("error deleting", error);
    }
  };

  const updateJobStatusWithEvent = async (
    eventTypeId: string,
    workerId?: string
  ) => {
    const body = {
      eventTypeId,
      workerId,
    };
    try {
      const j = await JobsAPI.createJobEvent(job.id, body);
      dispatch(editJob(j));
      if (eventTypeId === constants.eventType.requested) {
        dispatch(
          addRequest({
            jobId: job.id,
            personId: user.id,
          })
        );
      }
      setReviewingRequest(false);
      setMsg(getMessageForEventTypeSuccess(eventTypeId));

      dispatch(dismissRequestsForJobId(job.id));
      setShowMsg(true);

      if (
        eventTypeId === constants.eventType.accepted ||
        eventTypeId === constants.eventType.rejected
      ) {
        setLeavingRating(true);
        setApproving(false);
        setRejecting(false);
      } else {
        handleClose();
      }
    } catch (e) {
      alert(`Error: ${e}`);
      handleClose();
    }
  };

  const blockUser = async (workerId: string) => {
    try {
      const u = await UserAPI.block(workerId);
      // dispatch(setUser(u));

      setReviewingRequest(false);
      setMsg("User blocked");
      setShowMsg(true);

      // TODO remove from requests
    } catch (e) {
      alert(`Error: ${e}`);
      // handleClose();
    }
  };

  const closeDialog = () => {
    setPropertyId("");
    handleClose();
  };

  const getJobWasCompleted = () => {
    return completedStatuses.indexOf(job.statusId) > -1;
  };

  const claimButtonContent = () => {
    const isClaimable =
      job.assigneeId == null &&
      user.personTypeId == constants.personType.worker &&
      !getJobWasCompleted();
    const requested = requests.some((r: any) => r.jobId === job.id);
    if (isClaimable) {
      return (
        <Button
          variant="contained"
          disabled={requested}
          onClick={() => {
            updateJobStatusWithEvent(constants.eventType.requested);
          }}
        >
          {requested ? "Already Requested" : "Request Assignment"}
        </Button>
      );
    } else return null;
  };

  const completeButtonContent = () => {
    if (
      user.id === job.assigneeId &&
      job.statusId === constants.jobStatus.started
    ) {
      return (
        <Button
          variant="contained"
          startIcon={<CheckCircle />}
          onClick={onComplete}
        >
          Complete
        </Button>
      );
    } else return <></>;
  };

  const reviewRequestsButtonContent = () => {
    const isReviewable =
      job.assigneeId == null &&
      user.personTypeId == constants.personType.propertyManager &&
      user.id === job.managerId &&
      job.statusId === constants.jobStatus.open &&
      requests.some((r: any) => r.jobId === job.id);

    if (isReviewable) {
      return (
        <Button
          variant="contained"
          disabled={reviewingRequest}
          onClick={() => {
            setReviewingRequest(true);
          }}
        >
          View Requests
        </Button>
      );
    } else return null;
  };

  const startChatButtonContent = () => {
    const canStartChat =
      (job.assigneeId === user.id || job.managerId === user.id) &&
      chattableStatuses.indexOf(job.statusId) > -1;

    if (canStartChat) {
      return (
        <Button
          variant="contained"
          //   type="submit"
          onClick={() => {
            console.log("starting chat");
            navigate(`/messages?jobId=${job.id}`);
          }}
        >
          Chat
        </Button>
      );
    } else return null;
  };

  const reviewButtonsContent = () => {
    const reviewable =
      user.personTypeId == constants.personType.propertyManager &&
      job.statusId === constants.jobStatus.completed;
    if (reviewable) {
      return (
        <>
          <Button
            variant="contained"
            color="success"
            onClick={() => {
              setApproving(true);
            }}
          >
            Approve
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setRejecting(true);
            }}
          >
            Reject
          </Button>
        </>
      );
    } else return null;
  };

  const labelSty = { fontWeight: "700" };

  const getPropertyInfoString = () => {
    return `${
      job.property.bedrooms ? job.property.bedrooms + "-bedroom " : ""
    } ${
      job.property.bathrooms ? job.property.bathrooms + "-bathroom " : ""
    }${getPropertyTypeName(job.property.typeId)}`;
  };

  const assigneeContent =
    user.personTypeId === constants.personType.propertyManager &&
    job.assigneeId ? (
      <>
        <Grid2
          size={12}
          sx={{
            border: "1px none black",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography style={labelSty}>Assigned To:</Typography>
        </Grid2>
        <Grid2
          size={6}
          sx={{
            border: "1px none black",
            display: "flex",
            alignItems: "center",
          }}
        >
          <UserPanel
            name={job.assignee.name}
            id={job.assigneeId}
            rating={job.assignee.averageRating}
          />
        </Grid2>
        <Grid2
          size={6}
          sx={{
            border: "1px none black",
            display: "flex",
            alignItems: "center",
          }}
        >
          {startChatButtonContent()}
        </Grid2>
      </>
    ) : null;

  const managerContent =
    user.personTypeId === constants.personType.worker && job.managerId ? (
      <>
        <Grid2
          size={12}
          sx={{
            border: "1px solid black",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography style={labelSty}>Property Manager:</Typography>
        </Grid2>
        <Grid2
          size={6}
          sx={{
            border: "1px solid black",
            display: "flex",
            alignItems: "center",
          }}
        >
          <UserPanel name={job.manager.name} id={job.managerId} />
        </Grid2>
        <Grid2
          size={3}
          sx={{
            border: "1px solid black",
            display: "flex",
            alignItems: "center",
          }}
        >
          {startChatButtonContent()}
        </Grid2>
      </>
    ) : null;

  const getStartButton = () => {
    if (
      user.id === job.assigneeId &&
      job.statusId === constants.jobStatus.assigned
    ) {
      return (
        <Button
          variant="outlined"
          startIcon={<CheckCircle />}
          onClick={() => setStartingJob(job)}
        >
          Start
        </Button>
      );
    } else return <></>;
  };

  const getCompleteButton = () => {
    if (
      user.id === job.assigneeId &&
      job.statusId === constants.jobStatus.started
    ) {
      return (
        <Button
          variant="outlined"
          startIcon={<CheckCircle />}
          onClick={onComplete}
        >
          Complete
        </Button>
      );
    } else return <></>;
  };

  const getCancelButton = () => {
    if (
      user.personTypeId === constants.personType.propertyManager &&
      editableStatuses.indexOf(job.statusId) > -1 &&
      dayjs(job.endTime).isAfter(dayjs())
    ) {
      return (
        <Tooltip title="Cancel job">
          <Button
            variant="contained"
            color="error"
            style={mainButtonStyle}
            endIcon={<Close />}
            onClick={() => setJobToDelete(job)}
          >
            Cancel Job
          </Button>
        </Tooltip>
      );
    } else return <></>;
  };

  return (
    <>
      <Snackbar
        open={showMsg}
        autoHideDuration={6000}
        onClose={() => setShowMsg(false)}
        message={msg}
      >
        <Alert
          onClose={() => setShowMsg(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <JobCompleteDialog
        job={completingJob}
        open={!!completingJob.id}
        handleClose={() => {
          setCompletingJob({});
          handleClose();
        }}
      />
      <JobStartDialog
        job={startingJob}
        open={!!startingJob.id}
        handleClose={() => {
          setStartingJob({});
          handleClose();
        }}
      />
      <Dialog open={jobToDelete.id}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          {/* This action will delete {addressToString(propertyToDelete.address)} */}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              deleteJob(jobToDelete.id);
              setJobToDelete({} as any);
            }}
          >
            Yes
          </Button>
          <Button>no</Button>
        </DialogActions>
      </Dialog>
      <RequestsDialog
        open={reviewingRequest}
        handleClose={() => setReviewingRequest(false)}
        requests={filteredRequests}
        onAccept={(workerId: string) => {
          updateJobStatusWithEvent(constants.eventType.assigned, workerId);
        }}
        onBlock={(workerId: string) => {
          blockUser(workerId);
        }}
      />

      <Dialog open={rejecting}>
        <DialogContent>
          <DialogTitle>Are you sure?</DialogTitle>
          <Alert severity="warning">
            Provide a reason for rejecting this job.
          </Alert>
          <br />
          <TextField style={{ width: "100%" }}></TextField>
          <DialogActions style={{ justifyContent: "center" }}>
            <Button onClick={() => setRejecting(false)}>Cancel</Button>
            <Button
              color="error"
              variant="contained"
              onClick={() =>
                updateJobStatusWithEvent(constants.eventType.rejected)
              }
            >
              Reject
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog open={approving}>
        <DialogContent>
          <DialogTitle>Confirm Approval</DialogTitle>
          <Alert severity="success">You may leave a comment if you like.</Alert>
          <br />
          <TextField style={{ width: "100%" }}></TextField>
          <DialogActions style={{ justifyContent: "center" }}>
            <Button onClick={() => setApproving(false)}>Cancel</Button>
            <Button
              color="success"
              variant="contained"
              onClick={() =>
                updateJobStatusWithEvent(constants.eventType.accepted)
              }
            >
              Approve
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog open={leavingRating}>
        <DialogContent>
          <DialogTitle>Leave Rating</DialogTitle>
          <Alert severity="warning">
            Other property managers can see your comment.
          </Alert>
          <br />
          <Rating
            name="disabled"
            value={ratingValue}
            onChange={(e, v) => setRatingValue(v)}
          />
          <TextField
            style={{ width: "100%" }}
            value={ratingComment}
            onChange={(e) => setRatingComment(e.target.value)}
          ></TextField>
          <DialogActions style={{ justifyContent: "center" }}>
            <Button onClick={() => handleClose()}>Skip</Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => rateJob()}
              disabled={ratingValue === null}
            >
              Submit
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog open={showMap} onClose={() => setShowMap(false)}>
        <DialogContent>
          {job && job.id ? (
            <Map
              mapId="DEMO_MAP_ID"
              style={{ width: "300px", height: "300px" }}
              defaultZoom={17}
              defaultCenter={{
                lat: job.property.latitude,
                lng: job.property.longitude,
              }}
              disableDefaultUI
              maxZoom={17}
              minZoom={17}
            >
              <AdvancedMarker
                key={"job-location"}
                position={{
                  lat: job.property.latitude,
                  lng: job.property.longitude,
                }}
              >
                <Pin
                  background={"#FBBC04"}
                  glyphColor={"#000"}
                  borderColor={"#000"}
                />
              </AdvancedMarker>
            </Map>
          ) : null}
        </DialogContent>
      </Dialog>
      <Dialog
        open={open}
        onClose={closeDialog}
        maxWidth="xl"
        fullWidth
        fullScreen
      >
        <Box
          sx={{
            border: "1px none green",
            display: "flex",
            justifyContent: "right",
          }}
        >
          {" "}
          <Tooltip title="Close job">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Tooltip>
        </Box>
        <DialogTitle style={{ border: "1px none" }}>
          {getJobTypeName(job.typeId)} for{" "}
          <IconButton
            style={{ cursor: "default" }}
            onClick={() => {}}
            color="success"
          >
            {`$${job.fee}`}
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {job && job.property && job.property.address ? (
            <Grid2 container spacing={3} sx={{ border: "1px none green" }}>
              <Grid2
                size={12}
                sx={{
                  border: "1px none black",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography style={labelSty}>
                  Status: {getJobStatusName(job.statusId)}
                </Typography>
              </Grid2>
              {assigneeContent}
              {managerContent}
              <Grid2
                size={6}
                sx={{
                  border: "1px none black",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "left",
                }}
              >
                <Typography style={labelSty}>Location</Typography>
                <Typography variant="subtitle1">
                  {addressToStringFull(job.property.address)}
                </Typography>
              </Grid2>

              <Grid2
                size={6}
                sx={{
                  border: "1px none black",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "left",
                }}
              >
                <Tooltip title="View map">
                  <IconButton color="primary" onClick={() => setShowMap(true)}>
                    <MapOutlined />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Copy to clipboard">
                  <IconButton
                    color="primary"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        addressToStringFull(job.property.address)
                      );
                      setShowMsg(true);
                      setMsg("Copied address to clipboard");
                    }}
                  >
                    <ContentCopy />
                  </IconButton>
                </Tooltip>
              </Grid2>

              <Grid2
                size={6}
                sx={{
                  border: "1px none black",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "left",
                }}
              >
                <Typography style={labelSty}>Start Time</Typography>
                <Typography variant="subtitle1">
                  {timeToDayShort(job.startTime)}
                </Typography>
                <Typography variant="subtitle1">
                  {timeToTimeOfDayShort(job.startTime)}
                </Typography>
              </Grid2>
              <Grid2
                size={6}
                sx={{
                  border: "1px none black",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "left",
                }}
              >
                <Typography style={labelSty}>End Time</Typography>
                <Typography variant="subtitle1">
                  {timeToDayShort(job.endTime)}
                </Typography>
                <Typography variant="subtitle1">
                  {timeToTimeOfDayShort(job.endtime)}
                </Typography>
              </Grid2>

              <Grid2
                size={12}
                sx={{
                  border: "1px none black",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "left",
                }}
              >
                <Typography style={labelSty}>Property Info</Typography>
                <Typography> {getPropertyInfoString()}</Typography>

                {job.property.squareft ? (
                  <Typography> {job.property.squareft} Square Ft</Typography>
                ) : null}
                {job.property.acres ? (
                  <Typography> {job.property.acres} Acres</Typography>
                ) : null}
              </Grid2>

              {job.tasks && job.tasks.length > 0 ? (
                <>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography style={labelSty}>Tasks</Typography>
                  </Grid2>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {job.tasks.map((tId: string) => {
                        const t = tasks.find((task: any) => task.id === tId);
                        if (t) {
                          return (
                            <FormControlLabel
                              label={t.name}
                              control={<Checkbox defaultChecked={true} />}
                            />
                          );
                        } else return null;
                      })}
                    </div>
                  </Grid2>
                </>
              ) : null}
              {job.instructions && job.instructions.trim() !== "" ? (
                <>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography style={labelSty}>
                      Additional Instructions
                    </Typography>
                  </Grid2>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {job.instructions}
                  </Grid2>
                </>
              ) : null}

              {job.property.access ? (
                <>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography style={labelSty}>Access Information</Typography>
                  </Grid2>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {job.property.access}
                  </Grid2>
                </>
              ) : null}
              {job.events && job.events.length > 0 ? (
                <>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography style={labelSty}>History</Typography>
                  </Grid2>
                  <Grid2
                    size={8}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <JobHistory events={job.events || []} />
                  </Grid2>
                </>
              ) : (
                <></>
              )}
              {beforeImages && beforeImages.length > 0 ? (
                <>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography style={labelSty}>Before photos</Typography>
                  </Grid2>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Carousel>
                      {beforeImages.map((i: string) => {
                        return (
                          <div>
                            <img
                              src={`https://storage.googleapis.com/${process.env.REACT_APP_PHOTOS_BUCKET}/${job.id}/${i}`}
                              alt={`image_${i}`}
                            />
                            {/* <p className="legend">Legend 1</p> */}
                          </div>
                        );
                      })}
                    </Carousel>
                  </Grid2>
                </>
              ) : (
                <></>
              )}
              {afterImages && afterImages.length > 0 ? (
                <>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography style={labelSty}>After photos</Typography>
                  </Grid2>
                  <Grid2
                    size={12}
                    sx={{
                      border: "1px none black",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box>
                      <Carousel>
                        {afterImages.map((i: string) => {
                          return (
                            <div>
                              <img
                                src={`https://storage.googleapis.com/${process.env.REACT_APP_PHOTOS_BUCKET}/${job.id}/${i}`}
                                alt={`image_${i}`}
                              />
                              {/* <p className="legend">Legend 1</p> */}
                            </div>
                          );
                        })}
                      </Carousel>
                    </Box>
                  </Grid2>
                </>
              ) : (
                <></>
              )}
            </Grid2>
          ) : null}
        </DialogContent>
        <DialogActions>
          {job.assigneeId === null ? (
            <Button onClick={handleClose}>Cancel</Button>
          ) : null}
          {getCancelButton()}
          {getStartButton()}
          {getCompleteButton()}
          {claimButtonContent()}
          {completeButtonContent()}
          {reviewButtonsContent()}
          {reviewRequestsButtonContent()}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default JobDetailsDialog;
